import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ServerService } from './ServerService';

export type StatusRecursoCliente = 'ATIVO' | 'INCLUIDO' | 'PENDENTE' | 'DISPONIVEL';
export type ContratacaoRecurso = 'PAGO' | 'CONSULTAR' | 'GRATUITO';
export type StatusInteresseRecurso = 'NOVO' | 'EM_CONTATO' | 'CONCLUIDO';
export type OrigemInteresseRecurso = 'catalogo' | 'produtos' | 'pedidos' | 'loja' | 'dashboard';

export interface ModuloCatalogoCliente {
  slug: string;
  titulo: string;
  descricaoCurta: string;
  categoria: string;
  ordem: number;
  gratuito: boolean;
  agrupador: boolean;
}

export interface RecursoCliente {
  slug: string;
  titulo: string;
  descricaoCurta: string;
  tipo: string;
  categoria: string;
  recursoPaiSlug: string | null;
  recursoPai: ModuloCatalogoCliente | null;
  moduloId: number | null;
  ordem: number;
  gratuito: boolean;
  ativo: boolean;
  pendente: boolean;
  status: StatusRecursoCliente;
  contratacao: ContratacaoRecurso;
}

export interface InteresseRecurso {
  id: number;
  empresa: { id: number; nome: string; dominio: string };
  usuario: { id: number; nome: string; email: string } | null;
  recurso: { slug: string; titulo: string };
  origem: OrigemInteresseRecurso;
  status: StatusInteresseRecurso;
  criadoEm: string;
  atualizadoEm: string;
}

export interface CatalogoDescobertaRecursos {
  recursos: RecursoCliente[];
  interesses: InteresseRecurso[];
}

@Injectable({ providedIn: 'root' })
export class DescobertaRecursosService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  obtenhaCatalogo(): Promise<CatalogoDescobertaRecursos> {
    return this.obtenha('/recursos-cliente', {});
  }

  registreInteresse(slug: string, origem: OrigemInteresseRecurso): Promise<InteresseRecurso> {
    return this.facaPost(`/recursos-cliente/${encodeURIComponent(slug)}/interesse`, { origem });
  }
}
